/* eslint-disable no-restricted-imports */
import NextLink from '~/client/shared/NextLink';
import useGameTitle from './hooks/useGameTitle';

const GameTitle: FC = () => {
  const { name, providerName, href } = useGameTitle();
  return (
    <div>
      <NextLink href={href}>
        <p className="block text-moon-10-caption font-normal uppercase text-trunks">
          {providerName}
        </p>
      </NextLink>
      <h1 className="font-headline text-lg   !font-normal text-white">{name}</h1>
    </div>
  );
};

export default GameTitle;
